<template>
  <div class="container">
    <div class="info">
      <van-sticky>
        <!-- 顶部 -->
        <div class="top">
          <div class="titless">{{ $t('position').title }}</div>
          <!-- tab切换 -->
          <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
          <!-- 产品业务 -->
          <div class="businesstabs">
            <span v-for="(item, index) in tabsBusiness" :key="`tabbus${index}`" :class="activeBusiness == item.value ? 'active' : ''" @click="changeBusinessTab(item.value)">{{ item.name
              }}</span>
          </div>
          <!-- 标题 -->
          <div class="title">
            <!-- 产品 -->
            <div class="name">{{ $t('position').product }}</div>
            <!-- 杠杆 -->
            <span v-if="activeBusiness == 1||activeBusiness == 2">{{ $t('position').Leverageratio }}</span>
            <!-- 方向 -->
            <span>{{ $t('position').direction }}</span>
            <!-- 最新价格 -->
            <span>{{ $t('position').Currentprice }}</span>
            <!-- 止盈价格 -->
            <span v-if="activeBusiness == 1||activeBusiness == 2">{{ $t('position').stopSurplusPrice }}</span>
            <!-- 止损价格 -->
            <span v-if="activeBusiness == 1||activeBusiness == 2">{{ $t('position').Stoplossprice }}</span>
            <!-- 委托价格 -->
            <span>{{ $t('position').Entrustedprice }}</span>
            <!-- 委托数量 -->
            <span v-if="activeBusiness != 4">{{ $t('position').Entrustednum }}</span>
            <!-- 保证金 -->
            <span v-if="activeBusiness == 1||activeBusiness == 2">{{ $t('position').margin }}</span>
            <!-- 手续费 -->
            <span v-if="activeBusiness != 3">{{ $t('position').changeRate }}</span>
            <!-- 市值 -->
            <span v-if="active != '3' && (activeBusiness == 1||activeBusiness == 2)">{{ $t('position').marketvalue }}</span>
            <!-- 订单金额 -->
            <span v-if="activeBusiness == 3||activeBusiness == 4">{{ $t('position').orderAmount }}</span>
            <!-- 订单号 -->
            <span>{{ $t('position').orderno }}</span>
            <!-- 委托时间 -->
            <span>{{ $t('position').Entrustedtime }}</span>
            <!-- 盈亏 -->
            <span v-if="activeBusiness != 3">{{ $t('position').profitloss }}</span>
            <!-- 结算价格 -->
            <span v-if="active == '3' &&(activeBusiness == 1||activeBusiness == 2)">{{ $t('position').SettlementPrice }}</span>
            <!-- 结算时间 -->
            <span v-if="active == '3' && activeBusiness != 3">{{ $t('position').Settlementtime }}</span>
            <!-- 操作 -->
            <span v-if="active != '3'&&activeBusiness != 4">{{ $t('market').operate }}</span>
          </div>
        </div>
      </van-sticky>
      <!-- 订单列表 -->
      <div class="orderList">
        <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList" :immediate-check="false">
          <div class="item" v-for="(dItem, dIndex) in oList" :key="`order${dIndex}`">
            <!-- 产品 -->
            <div class="name">{{ dItem.name }}</div>
            <!-- 杠杆 -->
            <span v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">{{ dItem.lever }}</span>
            <!-- 方向 -->
            <span v-if="dItem.productBusiness == 3" :class="dItem.buyDirection == '0' ? 'green' : 'red'">
              {{ dItem.buyDirection == '0' ? $t('trade').buyBtn : $t('trade').sellBtn }}</span>
            <span v-if="dItem.productBusiness == 1||dItem.productBusiness == 2" :class="dItem.buyDirection == '0' ? 'green' : 'red'">
              {{ dItem.buyDirection == '0' ? $t('trade').Kato :  $t('trade').Openempty }}</span>
            <span v-if="!dItem.productBusiness" :class="dItem.buyDirection == '0' ? 'green' : 'red'">
              {{ dItem.buyDirection == '0' ? $t('trade').buyUp :  $t('trade').buyDown }}</span>
            <!-- 最新价格 -->
            <span :class="dItem.priceChangeRatio > 0 ? 'green' : 'red'">{{ dItem.newPrice }}</span>
            <!-- 止盈价格 -->
            <span v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">{{ dItem.stopSurplusPrice || '-' }}</span>
            <!-- 止损价格 -->
            <span v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">{{ dItem.stopLossPrice }}</span>
            <!-- 委托价格 -->
            <span>{{ dItem.price }}</span>
            <!-- 委托数量 -->
            <span v-if="dItem.productBusiness">{{ dItem.quantity }}</span>
            <!-- 保证金 -->
            <span v-if="dItem.productBusiness == 1||dItem.productBusiness == 2">{{ dItem.margin }}</span>
            <!-- 手续费 -->
            <span v-if="dItem.productBusiness != 3">{{ dItem.changeRate||'-' }}</span>
            <!-- 市值 -->
            <span v-if="active != '3' && (dItem.productBusiness == 1||dItem.productBusiness == 2)">{{ (dItem.newPrice *
              dItem.quantity).toFixed(6).replace(/\.?0+$/, '') }}</span>
            <!-- 订单金额 -->
            <span v-if="dItem.productBusiness == 3||!dItem.productBusiness">{{ dItem.amount }}</span>
            <!-- 订单号 -->
            <span class="txt">{{ dItem.orderNo }}</span>
            <!-- 委托时间 -->
            <span class="txt">{{ dItem.createTime | getLocalTime }}</span>
            <!-- 盈亏 -->
            <span v-if="active != '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2)" :class="dItem.profitAmount_new > 0 ? 'green' : 'red'">{{
                dItem.profitAmount_new }}<br>{{ dItem.profitRate_new }}%</span>
            <!-- 盈亏 -->
            <span v-if="active == '3' &&  (dItem.productBusiness == 1||dItem.productBusiness == 2)" :class="dItem.profitAmount > 0 ? 'green' : 'red'">{{
              dItem.profitAmount }}<br>{{(dItem.profitAmount/dItem.margin* 100).toFixed(2).replace(/\.?0+$/, '') }}%</span>
            <!-- 盈亏 秒合约-->
            <span v-if="!dItem.productBusiness" :class="dItem.profitAmount > 0 ? 'green' : 'red'">
              {{ dItem.profitAmount||'-' }}</span>
            <!-- 结算价格 -->
            <span v-if="active == '3' && (dItem.productBusiness == 1||dItem.productBusiness == 2)">{{ dItem.salesPrice }}</span>
            <!-- 结算时间 -->
            <span v-if="active == '3' && dItem.productBusiness != 3" class="txt">{{ dItem.salesTime | getLocalTime
            }}</span>
            <div class="btnInfo" v-if="active != '3'&& dItem.productBusiness">
              <!-- 取消 -->
              <div class="b1 redbg" v-if="active == '1'" @click="toCancelOrder(dItem)">{{ $t('public').cancel }}</div>
              <!-- 设置止盈止损 -->
              <div class="b2" v-if="active == '2'" @click="toSetInfo(dItem)">{{ $t('position').Settakeprofitloss }}
              </div>
              <!-- 平仓 -->
              <div class="b1 redbg" v-if="active == '2'" @click="toSettleOrder(dItem)">{{ $t('position').closeposition
              }}
              </div>
            </div>
          </div>
        </van-list>
        <div class="empty" v-if="isEmpty">
          <svg-icon class-name="esvgs" icon-class="empty" />
          <div class="txt">{{ $t('public').emptyTxt }}</div>
        </div>
      </div>
      <!-- 设置止盈止损 -->
      <van-popup v-model="showSetInfo" closeable :style="{ width: '350px' }">
        <div class="setInfo">
          <div class="name">{{ orderInfo.name }}
            <span :class="orderInfo.buyDirection == '0' ? 'green' : 'red'">{{
              orderInfo.buyDirection == '0' ? $t('trade').buy : $t('trade').sell }}</span>
            <span :class="orderInfo.priceChangeRatio > 0 ? 'green' : 'red'">{{ orderInfo.priceChangeRatio }}%</span>
          </div>
          <!-- 止盈价 -->
          <div class="item" v-if="orderInfo.stopSurplusPrice">{{ $t('position').stopSurplusPrice }} <span>${{
            orderInfo.stopSurplusPrice }}</span></div>
          <!-- 当前价 -->
          <div class="item">{{ $t('position').Currentprice }} <span :class="orderInfo.priceChangeRatio > 0 ? 'green' : 'red'">${{ orderInfo.newPrice
              }}</span></div>
          <!-- 止损价 -->
          <div class="item" v-if="orderInfo.stopLossPrice">{{ $t('position').Stoplossprice }} <span>${{
            orderInfo.stopLossPrice }}</span></div>
          <div class="item">
            <van-field v-model="StopSurplusPrice" type="number" :label="$t('trade').zyPrice" />
            <van-field style="margin-left: 15px;" v-model="StopLossPrice" type="number" :label="$t('trade').zsPrice" />
          </div>
          <div class="btns">
            <div class="b1" @click="showSetInfo = false">{{ $t('public').cancel }}</div>
            <div class="b2" @click="stopOrderSet">{{ $t('public').confirm }}</div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import orderApi from '@/api/order'
import { webSocket } from "@/mixins/webSocket.js";

export default {
  mixins: [webSocket],
  components: {
  },
  data() {
    return {
      isEmpty: false,
      showSetInfo: false,
      StopSurplusPrice: '',
      StopLossPrice: '',
      active: "1",
      //产品业务
      activeBusiness: 1,
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
      orderInfo: {},
      timer: null,
    }
  },
  computed: {
    tabs() {
      return [{
        "name": this.$t('position').Position,
        "value": "1"
      }, {
        "name": this.$t('position').commission,
        "value": "2"
      }, {
        "name": this.$t('position').Settlement,
        "value": "3"
      },
      ]
    },
    tabsBusiness() {
      return [{
        name: this.$t('public').USDTcontract,
        value: 1
      },
      // {
      //   name: this.$t('public').Fiatcurrencycontract,
      //   value: 2
      // },
      {
        name: this.$t('public').spot,
        value: 3
      }, {
        name: this.$t('public').secondContract,
        value: 4
      }]
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.refreshOrderList()
    this.timer = setInterval(() => {
      this.getNowPageOrderList();
    }, 3000);
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
    clearInterval(this.timer);
  },
  methods: {
    //切换
    changeTab(val) {
      this.active = val
      this.refreshOrderList()
    },
    //切换产品业务
    changeBusinessTab(val) {
      this.activeBusiness = val
      this.refreshOrderList()
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      if (this.activeBusiness == 4) this.getSecondOrderList()
      else this.getOrderList()
    },
    // 轮训刷新当前页订单列表
    async getNowPageOrderList() {
      if (this.isRun) return
      const currentPage = this.parms.pageNum > 1 ? this.parms.pageNum - 1 : 1;
      const startIndex = (currentPage - 1) * this.parms.pageSize;
      const parms = {
        ...this.parms,
        productBusiness: this.activeBusiness,
        status: this.active,
        pageNum: currentPage
      }
      var res = null
      if (this.activeBusiness == 4) {
        res = await orderApi.getSecondOrderList(parms)
      }
      else res = await orderApi.getOrderList(parms)
      const newRows = res.rows;
      // 用 Map 快速查找当前页已有订单对应索引
      const idMap = new Map();
      for (let i = startIndex; i < Math.min(this.oList.length, startIndex + this.parms.pageSize); i++) {
        const item = this.oList[i];
        if (item && item.orderId) idMap.set(item.orderId, i);
      }
      // 遍历新数据，根据 id 更新已有对象
      newRows.forEach(item => {
        if (idMap.has(item.orderId)) {
          // 更新已有对象字段
          Object.assign(this.oList[idMap.get(item.orderId)], item);
        } else {
          // 新增订单直接替换对应位置（保证页大小不变）
          const insertIndex = startIndex + newRows.indexOf(item);
          this.oList[insertIndex] = item;
        }
      });
      // 删除当前页里已经不存在的订单
      const newIds = new Set(newRows.map(i => i.orderId));
      for (let i = Math.min(this.oList.length - 1, startIndex + this.parms.pageSize - 1); i >= startIndex; i--) {
        if (!newIds.has(this.oList[i]?.orderId)) {
          this.oList.splice(i, 1);
        }
      }
    },
    // 获取订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.productBusiness = this.activeBusiness
      this.parms.status = this.active
      const res = await orderApi.getOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 获取秒合约订单列表
    async getSecondOrderList() {
      if (this.isRun) return
      this.isEmpty = false
      this.isRun = true
      this.parms.status = this.active
      const res = await orderApi.getSecondOrderList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      if (this.oList.length == 0) {
        this.isEmpty = true
      } else {
        this.isEmpty = false
      }
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送列表
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.oList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 订单列表
        that.oList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            that.$set(sItem, 'newPrice', quotes.NewPrice)
            that.$set(sItem, 'priceChangeRatio', quotes.PriceChangeRatio)
            // 非历史成交订单
            if (that.active != '3') {
              // 盈亏=持仓订单(产品价格-购买单价)【绝对值】x数量
              var profit = (Math.abs(sItem.price - quotes.NewPrice) * sItem.quantity)
              //买涨 价格下跌
              if (sItem.buyDirection == '0' && sItem.price > quotes.NewPrice)
                profit = -profit
              //买跌 价格上涨
              if (sItem.buyDirection == '1' && sItem.price < quotes.NewPrice)
                profit = -profit
              //盈亏要减去手续费
              that.$set(sItem, 'profitAmount_new', (profit - sItem.changeRate).toFixed(4).replace(/\.?0+$/, ''))
              that.$set(sItem, 'profitRate_new', (sItem.profitAmount_new / sItem.margin * 100).toFixed(2).replace(/\.?0+$/, ''))
            }
          }
        })
      })
    },
    // 展示止盈止损
    toSetInfo(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      this.showSetInfo = true
      this.StopSurplusPrice = null
      this.StopLossPrice = null
    },
    //设置止盈止损
    async stopOrderSet() {
      const form = {
        orderId: this.orderInfo.orderId,
        stopSurplusPrice: this.StopSurplusPrice,
        stopLossPrice: this.StopLossPrice,
      }
      await orderApi.stopOrderSet(form)
      this.$toast(this.$t('position').Settingsuccessful)
      this.showSetInfo = false
      this.refreshOrderList()
    },
    // 平仓确认弹窗
    async toSettleOrder(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      if (!this.orderInfo.newPrice) return
      this.$dialog.confirm({
        title: this.$t('position').Confirmclosingorder,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.settleOrder()
        })
    },
    // 平仓
    async settleOrder() {
      await orderApi.settleOrder({ orderId: this.orderInfo.orderId, marketPrice: this.orderInfo.newPrice })
      this.$toast(this.$t('position').Closingsuccessfully)
      this.refreshOrderList()
    },
    // 取消订单确认弹窗
    async toCancelOrder(val) {
      this.orderInfo = JSON.parse(JSON.stringify(val));
      this.$dialog.confirm({
        title: this.$t('position').cancelorder,
        confirmButtonText: this.$t('public').confirm,
        confirmButtonColor: 'var(--text_color)',
        cancelButtonText: this.$t('public').cancel,
        cancelButtonColor: 'var(--ntext_color)',
      })
        .then(() => {
          this.cancelOrder()
        })
    },
    // 取消订单
    async cancelOrder() {
      await orderApi.cancelOrder({ orderId: this.orderInfo.orderId })
      this.$toast(this.$t('position').Cancelsuccessfully)
      this.refreshOrderList()
    },
    //复制方法
    onCopy(text) {
      return new Promise((resolve) => {
        if (navigator.clipboard?.writeText) {
          this.$toast(this.$t('public').copySuccess)
          return resolve(navigator.clipboard.writeText(text))
        }
        const textarea = document.createElement('textarea')
        document.body.appendChild(textarea)
        textarea.style.position = 'absolute'
        textarea.style.clip = 'rect(0 0 0 0)'
        textarea.value = text
        textarea.select()
        document.execCommand('copy', true)
        textarea.remove()
        this.$toast(this.$t('public').copySuccess)
        return resolve(true)
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 100px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 1440px;

    .top {
      padding-top: 80px;
      margin: 0 auto;
      max-width: 1440px;
      background: var(--background_color);

      .titless {
        font-size: 36px;
        font-weight: bold;
        color: var(--text_color);
      }

      .tabs {
        margin-top: 10px;
        font-size: 16px;
        color: var(--ntext_color);
        border-bottom: 1px solid var(--info_color);
        display: flex;
        align-items: center;

        span {
          padding: 20px 0;
          margin-right: 30px;
        }

        .active {
          font-weight: bold;
          color: var(--primary_color);
          padding-bottom: 18px;
          border-bottom: 2px solid var(--primary_color);
        }
      }

      .businesstabs {
        display: flex;
        align-items: center;
        color: var(--ntext_color);
        font-size: 15px;
        padding: 15px 0;

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px 15px;
          margin-right: 20px;
        }

        .active {
          background: var(--primary_color);
          border-radius: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px 15px;
          color: #fff;
        }
      }

      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        font-size: 14px;
        height: 40px;
        padding: 0 10px;
        border-bottom: 1px solid var(--info_color);

        .name {
          width: 200px;
        }

        span {
          margin-left: 10px;
          width: 100px;
          text-align: center;
        }
      }
    }

    .orderList {
      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 10px;
        color: var(--text_color);
        font-size: 14px;
        border-bottom: 1px solid var(--info_color);

        &:hover {
          background: var(--info_color);
        }

        .name {
          width: 200px;
        }

        span {
          margin-left: 10px;
          width: 100px;
          word-break: break-all;
          text-align: center;
        }

        .txt {
          font-size: 12px;
        }

        .btnInfo {
          width: 100px;
          text-align: center;

          .b1 {
            padding: 7px 0;
            border-radius: 5px;
            font-size: 10px;
            color: #fff;
          }

          .b2 {
            margin-bottom: 10px;
            padding: 7px 0;
            border-radius: 5px;
            font-size: 10px;
            color: #fff;
            background: var(--primary_color);
          }
        }
      }

      .empty {
        margin-top: 50px;
        text-align: center;

        .esvgs {
          width: 50px;
          height: 50px;
        }

        .txt {
          margin-top: 30px;
          font-size: 12px;
          color: var(--text_color);
        }
      }
    }

    .orderInfo {
      padding: 30px;

      .name {
        font-size: 21px;
        font-weight: bold;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
          font-size: 15px;
          font-weight: normal;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        font-size: 15px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }

      .btn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        border-radius: 25px;
        font-size: 15px;
        color: var(--background_color);
        background: var(--text_color);

        &:hover {
          opacity: 0.8;
        }
      }

      .btns {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .b1 {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          border-radius: 25px;
          font-size: 15px;
          color: var(--text_color);
          background: var(--info_color);

          &:hover {
            opacity: 0.8;
          }
        }

        .b2 {
          margin-left: 15px;
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
          border-radius: 25px;
          font-size: 15px;
          color: var(--background_color);
          background: var(--text_color);

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    .setInfo {
      padding: 30px;

      .name {
        font-size: 21px;
        font-weight: bold;
        color: var(--text_color);
        display: flex;
        align-items: center;

        span {
          margin-left: 10px;
          font-size: 15px;
          font-weight: normal;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        font-size: 15px;
        color: var(--ntext_color);

        span {
          color: var(--text_color);
        }
      }

      .btns {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;

        .b1 {
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
          border-radius: 20px;
          font-size: 15px;
          color: var(--text_color);
          background: var(--background_color);

          &:hover {
            opacity: 0.8;
          }
        }

        .b2 {
          margin-left: 15px;
          width: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
          border-radius: 20px;
          font-size: 15px;
          color: var(--background_color);
          background: var(--text_color);

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}

::v-deep .van-popup--bottom {
  border-radius: 15px 15px 0 0;
  background: var(--background_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--info_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__label {
  margin-right: 5px;
  display: flex;
  align-items: center;
  color: var(--ntext_color);
  width: auto;
  font-size: 12px;
  font-weight: normal;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
}

::v-deep .van-cell {
  background: var(--info_color);
  border: 1px solid var(--ntext_color);
  border-radius: 10px;
  padding: 0 10px;
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  height: 40px;
}
</style>
